import React, { useContext, useEffect, useState } from 'react'
import SearchBar from '../../../../common/searchbar/SearchBar'
import Button from '../../../../common/button/Button'
import CollapsableButton from '../../../../common/button/CollapsableButton'
import { useParams } from 'react-router-dom'
import MicroModal from 'micromodal'
import { addMemberModalId } from '../form/Utils'
import { TeamContext } from '../../MenuTabs/MenuTabs'
import { notAllowedUserMembershipStatus } from '../Members/Utils'
import { modalInviteLinkId } from '../PendingInvites/Utils'
import RenderImportCSV from '../form/RenderImportCSV'
import useMemberTable from '../context/MemberTableContext'
import { useGroupDashboardContext } from '../../GroupDashboardContext'
import MembersFilter from './Filter/MembersFilter'
import MembersAction from './Actions/MembersAction'

const MemberHeader = ({
  from,
  tableData,
  globalFilter,
  setGlobalFilter,
  selectedLength,
  rowSelection,
  setColumnFilters
}) => {

  const params = useParams()
  const teamId = params.team_id
  const modalId = addMemberModalId(teamId)
  const { teamData } = useContext(TeamContext)
  const { useHeader } = useMemberTable()
  const { setSelectedAddMemberModal } = useGroupDashboardContext()
  const actionTitle = `Bulk Actions ${ selectedLength !== 0 ? 'Selected (' + selectedLength + ')' : '' }`

  const handleAddMember = () => {
    if ( teamData.team_type === 'wooteams' ) {
      setSelectedAddMemberModal({
        teamId: teamId,
        remainingSeats: teamData.team_remaining_seats,
        seatCount: teamData.team_seat_count,
        teamType: teamData.team_type
      })
    } else if ( teamData.team_type === 'msynclicenses' ) {
      setSelectedAddMemberModal({
        teamId: teamId,
        teamType: teamData.team_type
      })
    }
    MicroModal.show(modalId)
  }

  return (
    <>
      <div className='msync-table__header'>
        <div className='msync-table__header__part msync-table__header__part--members-filter'>
          {
            ( useHeader.includes('all') || useHeader.includes('filter') ) && 
            <MembersFilter 
              from={ from }
              tableData={ tableData } 
              setColumnFilters={ setColumnFilters } 
            />
          }
          {
            ( useHeader.includes('all') || useHeader.includes('search') ) && 
            <SearchBar
              globalFilter={ globalFilter } 
              setGlobalFilter={ setGlobalFilter }
            />
          }
        </div>
        <div className='msync-table__header__part msync-table__header__part--members-action'>
          {
            ( useHeader.includes('all') || useHeader.includes('actions') ) && teamData.member_role !== 'member' && 
            <CollapsableButton
              collapsed={false}
              icon={''}
              title={ actionTitle }
              heightWidth={12}
              disabled={ tableData.length === 0 }
            >
              <MembersAction
                from={ from }
                tableData={ tableData }
                selectedLength={selectedLength}
                rowSelection={rowSelection}
              />
            </CollapsableButton>
          }
          { 
            ( useHeader.includes('all') || useHeader.includes('import-csv') ) && teamData.member_role !== 'member' &&
            <RenderImportCSV teamId={ teamId } teamType={ teamData.team_type } />
          }
          {/* {
            ( useHeader.includes('all') || useHeader.includes('deallocate') ) && 
            <Button
              className='msync-outline-primary-btn'
              name='Deallocate'
            />
          } */}
          {
            teamData.team_type === 'wooteams' && ( useHeader.includes('all') || useHeader.includes('invite-link') ) && 
            <Button 
              className='msync-button--is-style-outline'
              name='Invite Link'
              onClick={ () => MicroModal.show(modalInviteLinkId) }
            />
          }
          {
            ( teamData.can_add_members || teamData.team_type !== 'msynclicenses' ) && ( ( useHeader.includes('all') || useHeader.includes('add-member') ) &&
            ( notAllowedUserMembershipStatus.includes(teamData.current_user_membership?.membership_status) 
            ? <button type='button' className='msync-btn msync-primary-btn' disabled>Add Member</button>
            : <> 
                <Button
                  onClick={ () => handleAddMember() }
                >
                  Add Member
                </Button>
              </>
            ) )
          }
        </div>
      </div>
    </>
  )
}

export default MemberHeader
